// extracted by mini-css-extract-plugin
export default {"barislogin":"Login_barislogin__FkB3i","formlogin":"Login_formlogin__3dxoz","colsatu":"Login_colsatu__dhukm"};